import localforage from "localforage";
import axios from "axios";
import { useProject } from "./project";

const API = "https://polotno-studio-api.vercel.app/api";

// Host de l'API B4Food. `api.b4food.ultim-erp.com` est MORT (503) -> prod = api.b4food.io.
// Pilotable par REACT_APP_API_URL ; fallback = PROD (jamais le host mort).
const API2 = process.env.REACT_APP_API_URL || 'https://api.b4food.io';

// Tenant cible : l'éditeur (Auth0) n'a pas de JWT B4Food, donc on passe le tenant
// en query param (?tenant=) -> le backend résout la bonne base (sinon défaut FDLT).
// Pris dans l'URL de l'éditeur (?tenant=...), fallback = NEMROD pour l'instant.
const TENANT =
  new URLSearchParams(window.location.search).get("tenant") ||
  process.env.REACT_APP_TENANT_ID ||
  "6533fe68b1f4342903409c00";
// Ajoute ?tenant= ou &tenant= selon que l'URL a déjà un query.
const withTenant = (url) => url + (url.includes("?") ? "&" : "?") + "tenant=" + TENANT;

// Configure axios to send cookies with requests for shared auth
axios.defaults.withCredentials = true;


/* ─────────────────────────────────────────────────────────────────────────────
   GARDE-FOU : cet éditeur ne sait lire QUE le format Polotno.

   Depuis 2026-06, les gabarits de fiche technique sont convertis au format
   « studio-v1 » (`definition.pages[].elements`, en millimètres), que cet éditeur
   ne comprend pas : il n'y voit aucune page et affiche un canvas VIDE. Un simple
   « Enregistrer » écrase alors la définition du gabarit par du vide — et ce
   gabarit est celui dont dépendent les fiches techniques des produits.

   Le risque n'est pas théorique : au 2026-08-28, B4FOOD-NEMROD compte 20
   documents studio-v1 sur 21, et sa liste de gabarits porte un bouton qui ouvre
   cet éditeur.

   On refuse donc l'ouverture ET l'enregistrement. Le bon outil pour ces
   documents est le Studio (studio.ayumia.com, ou /admin/studio/<id> dans l'ERP).
   ───────────────────────────────────────────────────────────────────────────── */
const MOTEUR_STUDIO = "studio-v1";
let gabaritsRefuses = new Set();

function estStudio(doc) {
  return !!doc && doc.definition_engine === MOTEUR_STUDIO;
}

/** Refuse le document et prévient l'utilisateur, une seule fois par gabarit. */
function refuserStudio(doc) {
  const id = doc && doc._id;
  if (id) gabaritsRefuses.add(String(id));
  const nom = (doc && doc.name) || "Ce gabarit";
  console.warn("editor: gabarit studio-v1 refusé —", nom, id);
  // `alert` et non une bannière : il faut ARRÊTER le geste avant que
  // l'utilisateur ne commence à travailler dans un canvas vide.
  if (typeof window !== "undefined" && window.alert) {
    window.alert(
      nom + " est un gabarit au format Studio.\n\n" +
      "Cet éditeur ne sait pas l'ouvrir : il afficherait une page vide, et " +
      "l'enregistrer effacerait le gabarit.\n\n" +
      "Ouvrez-le depuis le Studio (menu Gabarits de l'ERP)."
    );
  }
}

/** Le gabarit courant a-t-il été refusé plus tôt ? */
function dejaRefuse(id) {
  return id != null && gabaritsRefuses.has(String(id));
}

export async function getDesignById({ id, authToken }) {
  if (id == "local") id = "64c63aefae9f4714d49d6014";

  let url = withTenant(`${API2}/api/b4food/technical-sheet-templates/${id}`);

  try
  {
    let reponse = await axios.get(url);
    if (estStudio(reponse.data)) {
      refuserStudio(reponse.data);
      return {};
    }
    if (reponse.data.definition !== undefined) {
      return {
        store: reponse.data.definition,
        name: reponse.data.name,
        language: reponse.data.language,
        id: reponse.data._id,
      };
    }

  }
  catch(e)
  {
    console.error("Error loading design:", e);
  }



  return {};
  /*
  return {
    store: reponse.data.definition,
    name: reponse.data.name,
    id: reponse.data._id,
  };*/
}

export async function listDesigns({ accessToken }) {
  const req = await fetch(API + "/designs/list", {
    method: "GET",
    headers: {
      Authorization: accessToken,
    },
  });
  return req.json();
}

export async function getUserSubscription({ accessToken }) {
  const req = await fetch(API + "/user/subscription", {
    method: "GET",
    headers: {
      Authorization: accessToken,
    },
  });
  return req.json();
}

export async function cancelUserSubscription({ accessToken, id }) {
  const req = await fetch(API + "/user/cancel-subscription", {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  });
  return req.json();
}

export async function saveDesign({
  store,
  preview,
  id,
  authToken,
  name,
  language,
  isPrivate,
}) {
  // if (id === 'local' || !authToken) {
  // localforage.setItem('polotno-state', store);

  // Dernier rempart : même si une ouverture passait au travers, on n'écrit pas
  // par-dessus un gabarit studio.
  if (dejaRefuse(id)) {
    console.warn("editor: enregistrement refusé sur un gabarit studio-v1", id);
    if (typeof window !== "undefined" && window.alert) {
      window.alert("Enregistrement annulé : ce gabarit est au format Studio et doit être modifié depuis le Studio.");
    }
    return id;
  }

  let body = {
    definition: store,
  };
  if (id == undefined) {
    let body = {
      name: name,
      code: "-",
      tenant_id: "62f76a2df10a29ce8a81bdb5",
      tags: [],
      definition: {},
      version: "3",
      language: language,
    };
    let url = withTenant(`${API2}/api/b4food/technical-sheet-templates?version=3`);
    let json = await axios.post(url, body);
    console.log(json);
    id = json.data.insertedId;
  } else {
    body.name = name;
    console.log("Path Design ", name);

    //id="64de240bcc76bedff8d05d33"
    await axios.patch(
      withTenant(`${API2}/api/b4food/technical-sheet-templates/${id}`),
      body
    );
  }

  return {
    id: id,
    status: "saved",
  };
}

export async function deleteDesign({ id, authToken } = {}) {
  await localforage.clear();
  // const req = await fetch(`${API}/designs/delete`, {
  //   method: 'POST',
  //   headers: {
  //     Authorization: authToken,
  //     'Content-Type': 'application/json',
  //   },
  //   body: JSON.stringify({ id }),
  // });
  // return await req.json();
}

export async function listProjects({ accessToken }) {
  let url = withTenant(`${API2}/api/b4food/technical-sheet-templates?version=3`);
  let json = await axios.get(url);

  return json.data.records;
}

export async function createProject(name, { accessToken }) {
  let body = {
    name: name,
    code: "-",
    tenant_id: "62f76a2df10a29ce8a81bdb5",
    tags: [],
    definition: {},
    version: "3",
    language: "en",
  };
  let url = withTenant(`${API2}/api/b4food/technical-sheet-templates?version=3`);
  let json = await axios.post(url, body);
  console.log(json);
  return json.data.records.insertedId;
}

export async function loadTemplate({ accessToken, id }) {
  let url = withTenant(`${API2}/api/b4food/technical-sheet-templates/${id}`);
  let json = await axios.get(url);

  if (estStudio(json.data)) {
    // 🔴 On sort AVANT de toucher au store : la branche « pas de définition »
    // ci-dessous supprime les pages et en crée une vierge. Sur un document
    // studio, cela préparerait exactement le canvas vide qu'un enregistrement
    // viendrait figer en base.
    refuserStudio(json.data);
    return json.data;
  }

  if (json.data.definition == undefined) {
    const pagesIds = window.store.pages.map((p) => p.id);

    window.store.deletePages(pagesIds);
    //https://papersizes.online/paper-size/a4/pixels/
    //window.store.setSize(2480, 3508);
    //window.store.setDPI(300)

    window.store.setSize(595, 842);
    //window.store.setDPI(72)

    //A4 300dpi
    window.store.addPage();
    //let project = useProject();
    // project.id = id;
    // project.save();
  } else {
    window.store.loadJSON(json.data.definition);

    //let project = useProject();
    // project.id = json.data._id;
    // project.id = json.data.name;
    //project.save();
  }
  return json.data;
}
